export default {
  data () {
    return {
      paymentViaOptions: [
        'Unspecified',
        'Bank Transfer',
        'Cash',
        'Credit Card',
        'Cheque'
      ]
    }
  }
}
